import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useWarehouseOrderExpeditionService from '../../../app/services/hooks/useWareHouseOrderExpedition';
import { WarehouseExpeditionDataForm } from '../../../app/models/WareHouseQuoteExpedition';
import { Place } from '../../../app/models/Place';
import { Depot } from '../../../app/models/Depot';
import { RouteSegment } from '../../../app/models/RouteSegment';
import { Currency } from '../../../app/models/Currency';
import { Unit } from '../../../app/models/Unit';
import { AppContext } from '../../../contexts/AppContext';
import { PackingType } from '../../../app/models/PackingType';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import WarehouseOrderExpeditionForm from './forms/WareHouseOrderExpeditionForms/WareHouseOrderExpeditionForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { defaultWarehouseOrderExpeditionDataForm } from '../../../app/models/WareHouseOrderExpedition';
import { ExpeditionOptions } from '../../../app/models/ExpeditionOptions';



interface Props {
    expeditionId: number;
    onSaved: () => void;
    onCancel: () => void;
}
// editWarehouseOrderExpedition
const WarehouseOrderExpeditionEdit = ({ expeditionId, onSaved, onCancel }: Props) => {
    const { updateWarehouseOrderExpedition, editWarehouseOrderExpedition } = useWarehouseOrderExpeditionService();
    const [warehouseExpeditionform, setWarehouseExpeditionform] = useState<WarehouseExpeditionDataForm>({...defaultWarehouseOrderExpeditionDataForm});
    const [origins, setOrigins] = useState<Place[]>([]);
    const [destinations, setDestinations] = useState<Place[]>([]);
    const [depots, setDepots] = useState<Depot[]>([]);
    const [routeSegments, setRouteSegments] = useState<RouteSegment[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [units, setUnits] = useState<Unit[]>([]);
    const [packingTypes, setPackingTypes] = useState<PackingType[]>([]);
    const [errorFields, setErrorFields] = useState<any>();
    const [expetionsOptions, setExpetionsOptions] = useState<ExpeditionOptions[]>([]);
    
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    useEffect(() => {
        edit();
    }, [expeditionId]);
    
    const edit = () => {
            editWarehouseOrderExpedition(expeditionId, {
                onSuccess: (response: ServiceResponse) => {
                    const data = response.data.warehouse_order_expedition;
                    setWarehouseExpeditionform( response.data.warehouse_order_expedition);
                    setOrigins(response.data.origins);
                    setDestinations(response.data.destinations);
                    setDepots(response.data.depots);
                    setRouteSegments(response.data.route_segments);
                    setCurrencies(response.data.currencies);
                    setUnits(response.data.units);
                    setPackingTypes(response.data.packing_types);
                    setExpetionsOptions(response.data.expetions_options)
                
                },
                onError: (response: ServiceResponse) => {
                    toast.error('Error al cargar almacenamiento');
                }
            });
    };
    

    const update = () => {
        updateWarehouseOrderExpedition(expeditionId, warehouseExpeditionform, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
    
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
    
                toast.success(response.message, { autoClose: 2500 });
                setErrorFields(undefined);
                 if (onSaved) onSaved();

            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

    
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });

                toast.error(response.message);
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }
        });
    };

    return (
        <>
            <WarehouseOrderExpeditionForm
                expeditionDataForm={warehouseExpeditionform}
                setExpeditionDataForm={setWarehouseExpeditionform}
                origins={origins}
                destinations={destinations} 
                depots={depots}
                routeSegments={routeSegments}
                currencies={currencies}
                units={units}
                packingTypes={packingTypes}  
                expeditionOptions={expetionsOptions}
                errorFields={errorFields}
                />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={onCancel} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} />
                </div>
            </div>
        </>
    );
};

export default WarehouseOrderExpeditionEdit;
